import React from "react";

export const Services = (props) => {
  return (
    <div id="Services" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>Services</h2>
          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit duis sed
            dapibus leonec.
          </p> */}
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 text-center">
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.description}</p>
                    </div>
                  </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};